if (!customElements.get('design-online')) {
  class DesignOnline extends HTMLElement {
    constructor() {
      super();

      this._fetching = false;
      this.customerId = this.dataset.customerid;
      this.customButton = this.querySelector('.custom-button');

      this.variantSelects = document.querySelector('variant-selects');
      this.ButtonLoading = document.querySelector('.customizer-button');

      this.addEventListener('click', (e) => {
        e.preventDefault();

        this.getCustomizeUrl();
      });

      this.materialDropdown = document.querySelector('material-dropdown');
      if (this.materialDropdown) {
        this.materialDropdown.addEventListener('change', () => {
          this.hideDesignOnline();
        });

        this.hideDesignOnline();
      }
    }

    async connectedCallback() {
      // Espera a que custom-option esté definido
      await customElements.whenDefined('variant-selects');
      this.check();
    }

    get fetching() {
      return this._fetching;
    }

    set fetching(value) {
      this._fetching = value;

      this.classList.toggle('button-disable', value);

    }

    get size() {
      if (!this.variantSelects || !this.variantSelects.values || !this.variantSelects.values.size) {
        return null;
      }

      return this.variantSelects.values.size;
    }

    get printing() {
      if (!this.variantSelects || !this.variantSelects.values || !this.variantSelects.values.printing) {
        return null;
      }

      return this.variantSelects.values.printing;
    }

    get quantity() {
      if (!this.variantSelects || !this.variantSelects.values || !this.variantSelects.values.qty) {
        return null;
      }

      return this.variantSelects.values.qty;
    }

    get variantId() {
      if (!this.variantSelects || !this.variantSelects.currentVariant || !this.variantSelects.currentVariant.id) {
        return null;
      }

      return this.variantSelects.currentVariant.id;
    }

    get options() {
      if (!this.variantSelects || !this.variantSelects.options) {
        return null;
      }

      return this.variantSelects.options;
    }

    get properties() {
      if (!this.variantSelects || !this.variantSelects.properties) {
        return null;
      }

      return this.variantSelects.properties;
    }

    get productHandle() {
      if (!this.variantSelects || !this.variantSelects.productHandle) {
        return null;
      }

      return this.variantSelects.productHandle;
    }

    get values() {
      if(!this.variantSelects) return {};
      return this.variantSelects.values;
    }

    check() {
      if(this.variantSelects.dataset.type === 'extension-product' ) return true;
      if(!("material" in this.values)) return;
      if(this.values.material != 'white ink on kraft') {
        this.enable();
        return true;
      }
      this.disabled();
      return false;
    }

    disabled() {
      this.classList.add('hidden');
    }

    enable() {
      if(this.variantSelects.validInfo){
        this.classList.remove('hidden');
      }
    }

    async getCustomizeUrl() {
      if (this.fetching) return;
      if(!this.check()) return;

      try {
        this.fetching = true;

        this.ButtonLoading.classList.add('button-loading');

        const baseUrl = new URL(`${window.internalApi.baseUrl}/designs/personalization-url`);

        const payload = {variantId: this.variantId};

        if (this.size) payload.size = this.size;
        if (this.printing) payload.printing = this.printing;

        // check set exist customer user
        if (this.customerId && this.customerId !== '') {
          payload.customerId = this.customerId;
        }

        const res = await fetch(baseUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
        }).then((res) => res.json());

        if (!res.personalizationUrl) return;

        this.saveProductProperties();

        location.href = res.personalizationUrl;
      } catch (error) {
        console.log(error);
      } finally {
        this.fetching = false;
      }
    }

    saveProductProperties() {
      this.properties['_purchases'] = 'design-online';

      const productJson = {
        id: this.variantId,
        quantity: this.quantity,
        properties: this.properties,
      };

      localStorage.setItem(`design_${this.variantId}`, JSON.stringify(productJson));
    }

    hideDesignOnline() {
      let material = '';
      if (this.materialDropdown && this.materialDropdown.dataset.value) {
        material = this.materialDropdown.dataset.value.toLowerCase();
      }

      this.classList.toggle('hidden', material === 'white ink on kraft');
    }
  }

  customElements.define('design-online', DesignOnline);
}
